import PageHero from "@/components/PageHero";
import CTABanner from "@/components/CTABanner";
import { Reveal } from "@/components/Reveal";
import { useSite, ICONS } from "@/context/ContentContext";
import { ArrowRight, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

export default function ServicesPage() {
  const D = useSite();
  const p = D.pages.hizmetler;
  const banner = D.servicesBanner;
  return (
    <>
      <PageHero overline={p.overline} titleLines={p.titleLines} description={p.description} />

      <section className="mx-auto max-w-7xl px-6 pb-24 md:px-12">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {D.services.map((s, i) => {
            const Icon = ICONS[s.icon] || Sparkles;
            return (
              <Reveal key={s.title} delay={(i % 4) * 0.08} className="h-full">
                <div
                  data-testid={`services-page-card-${i}`}
                  className="group flex h-full flex-col rounded-3xl border border-charcoal-900/5 bg-white p-8 shadow-premium transition-all duration-500 ease-premium hover:-translate-y-1.5 hover:border-gold/30 hover:shadow-lift"
                >
                  <span className="font-serif text-lg text-gold/50 transition-colors duration-500 group-hover:text-gold">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div className="mt-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-gold/10 text-gold-dark transition-colors duration-500 group-hover:bg-gold/20">
                    <Icon
                      className="h-6 w-6 transition-transform duration-500 ease-premium group-hover:-rotate-6 group-hover:scale-110"
                      strokeWidth={1.5}
                    />
                  </div>
                  <h3 className="mt-6 font-serif text-xl tracking-tight text-charcoal-900">{s.title}</h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-muted-foreground">{s.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-6 pb-24 md:px-12">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2.5rem] shadow-lift">
            <img
              src={banner.image}
              alt="Ada yurdunda yaşam"
              loading="lazy"
              className="h-[440px] w-full object-cover md:h-[520px]"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-charcoal-950/75 via-charcoal-950/40 to-transparent" />
            <div className="absolute inset-0 flex items-center">
              <div className="max-w-lg p-10 md:p-16">
                <p className="font-accent text-[11px] uppercase tracking-[0.35em] text-gold-light">
                  {banner.overline}
                </p>
                <h2 className="mt-5 font-serif text-3xl leading-tight tracking-tight text-white md:text-4xl">
                  {banner.title}
                </h2>
                <p className="mt-5 text-sm leading-relaxed text-white/70 md:text-base">
                  {banner.text}
                </p>
                <Link
                  data-testid="services-cta-link"
                  to="/iletisim"
                  className="group mt-8 inline-flex items-center gap-2.5 rounded-full bg-white px-7 py-3.5 text-sm font-semibold text-charcoal-900 transition-all duration-500 ease-premium hover:-translate-y-0.5 hover:shadow-lift"
                >
                  {banner.ctaLabel}
                  <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </div>
            </div>
          </div>
        </Reveal>
      </section>

      <CTABanner />
    </>
  );
}
